import React from "react";
import { GoogleLogin } from "@react-oauth/google";

const GoogleSignIn = ({ handleSuccess: onSuccess, className }) => {

  const handleError = () => {
    alert("Login Failed");
  };

  return (
    <div
      className={className}
      style={{
        marginTop: "10px",
        marginBottom: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <GoogleLogin theme="filled_blue" onSuccess={onSuccess} onError={handleError} />
    </div>
  );
};

export default GoogleSignIn;
